import Vue from 'vue'
import Chat from 'vue-beautiful-chat'
Vue.use(Chat)

import SalvexChat from '@/components/Chat.vue'
import HeaderButton from '@/components/HeaderButton.vue'
import Navigation from '@/components/Navigation.vue'

Vue.config.productionTip = false;

import firebase from 'firebase';
import { db, auth } from '@/firebase';

if(window.CHAT_JWT_TOKEN){
  try{

    firebase.auth().onAuthStateChanged(async(user) => {
      if (!user) {
        user = await auth.signInWithCustomToken(window.CHAT_JWT_TOKEN);
      }
      if(user&&('uid' in user)){
        mountApp();
      }


    });

  }catch(e){
    console.log(e);
  }
}else{
  firebase.auth().signOut();
}

const mountApp = async () => {
  let user = firebase.auth().currentUser;
  let token = await user.getIdTokenResult();
  let d = token.claims;

  let userData = {
    name:(d.name?d.name:user.displayName),
    company:(d.company?d.company:''),
    location:(d.location?d.location:''),
    phone:(d.phone?d.phone:''),
    avatar:(d.avatar?d.avatar:user.photoURL),
    trader:(d.usertype=='trader'?true:false),
    customer:(d.usertype=='customer'?true:false),
    manages:(d.manages?d.manages:[])
  };

  Object.assign(user,userData);

  await db.collection('/users').doc(user.uid).set(userData,{merge:true});

  let $config = {
    TO:window.VCHAT_TO,
    FROM:{
      id:parseInt(user.uid),
      name:user.displayName,
      avatar:user.photoURL,
      customer:user.customer?true:false,
      trader:user.trader?true:false,
      location:user.location?user.location:null,
      phone:user.phone?user.phone:null,
      email:user.email?user.email:null,
      manages:(user.manages?user.manages:[])
    }
  }

  if(window.AUCTIONID) $config.AUCTIONID=window.AUCTIONID;
  if(window.AUCTIONTITLE) $config.AUCTIONTITLE=unescape(window.AUCTIONTITLE);
  if(window.AUCTIONIMAGE) $config.AUCTIONIMAGE=window.AUCTIONIMAGE;
  Vue.prototype.$config = $config;

  let app = null;
  let btn = new Vue(HeaderButton).$mount();
  let nav = new Vue(Navigation).$mount();
  if($config.AUCTIONID){
    app = new Vue(SalvexChat).$mount('#SalvexChat');
  }

  if(window.jQuery){
    let $ = window.jQuery;

    if($().mmenu) {
      $('#myaccountmenu').before(nav.$el);
      $('#threads ul').first().css('display','block');
      $('#google_translate_element').before(btn.$el);
      $('nav#threads').mmenu({classes:'mm-white',slidingSubmenus:false,searchfield:false,counters:true,header:{add:true,update:true,title:'MY CHATS'},offCanvas: {position  : "left"}});
    }

    if(app){
      let p = $('.sc-launcher').parent();
      p.css('position','absolute');
      p.css('bottom','0px');
      p.css('right','0px');
      p.css('zIndex','9999');
      $('#btnMountChat').on('click',()=>{
        app.openChat();
      });
    }

  }
}
